import { Component, forwardRef, OnChanges, SimpleChanges } from '@angular/core';

import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { DateRangeFieldComponent } from '../../../../Common/Reports/components/DateRangeField/date-range-field.component';
import { DateQueryModel } from '../../../../Common/Forms/models/date-query.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';

@Component({
    selector: 'agpr-surge-period-date-range-field',
    templateUrl: '../../../../Common/Reports/components/DateRangeField/date-range-field.component.html',
    styleUrls: ['../../../../Common/Reports/components/DateRangeField/date-range-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => SurgePeriodDateRangeFieldComponent)
        }
    ],
    standalone: false
})
export class SurgePeriodDateRangeFieldComponent extends DateRangeFieldComponent implements OnChanges {
    static readonly SURGE_PERIOD_DATE_RANGE: DateQueryModel = new DateQueryModel();

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.hasOwnProperty('value') || changes.hasOwnProperty('dateTypeOptions')) {
            this.dateFilterOptions = [
                ...this.dateFilterOptions,
                new DropdownOptionModel('Monitoring.sourcePickerField.surgePeriod', { query: SurgePeriodDateRangeFieldComponent.SURGE_PERIOD_DATE_RANGE })
            ];
            if ((this.block?.displayElement as any)?.useSearchDateFilter === false) {
                this.dateRange = SurgePeriodDateRangeFieldComponent.SURGE_PERIOD_DATE_RANGE;
            }
        }
    }

    override dateRangeChanged(dateRange: DateQueryModel): void {
        const isSurgePeriod = dateRange === SurgePeriodDateRangeFieldComponent.SURGE_PERIOD_DATE_RANGE;
        (this.block.displayElement as any).useSearchDateFilter = !isSurgePeriod;
        if (isSurgePeriod) {
            this.changes.emit(this.seriesList.slice());
            return;
        }
        super.dateRangeChanged(dateRange);
    }
}
